import {
  RecurringOption,
  RepeatDropdownOptions,
  RepeatDropdownOptionsType,
} from "../../types/block/enum";

export const recurringOptions = [
  RecurringOption.THIS,
  RecurringOption.THISANDAFTER,
  RecurringOption.ALL,
] as const;

export const TOOLTIP_LABELS: Record<RepeatDropdownOptionsType, string> = {
  [RepeatDropdownOptions.EVERY_DAY]: "Every Day",
  [RepeatDropdownOptions.EVERY_WEEKDAY]: "Every Weekday",
  [RepeatDropdownOptions.EVERY_WEEK]: "Every Week",
  [RepeatDropdownOptions.EVERY_MONTH]: "Every Month",
  [RepeatDropdownOptions.EVERY_YEAR]: "Every Year",
  [RepeatDropdownOptions.NEW_REPEAT_SETTINGS]: "Custom Repeat",
} as const;
